/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, WebAppGetFragmentSocialUploadsByFragmentIdPathParams } from "../models/WebAppGetFragmentSocialUploadsByFragmentId";

export function getWebAppGetFragmentSocialUploadsByFragmentIdUrl(fragmentId: WebAppGetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"]) {
  const res = { method: 'GET', url: `/web-app/v1/fragment-social-uploads/by-fragment/${fragmentId}` as const }
  return res
}

/**
 * @summary Get social uploads for a fragment
 * {@link /web-app/v1/fragment-social-uploads/by-fragment/:fragmentId}
 */
export async function webAppGetFragmentSocialUploadsByFragmentId(fragmentId: WebAppGetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getWebAppGetFragmentSocialUploadsByFragmentIdUrl(fragmentId).url.toString(), ... requestConfig })
  return res.data
}